import React from 'react';
import { ILS, formatFullDateTime } from '../../utils/salesUtils';

const METHOD_META = {
  Cash:     { ic: '💵', cls: 'cash'     },
  Card:     { ic: '💳', cls: 'card'     },
  Bit:      { ic: '📱', cls: 'bit'      },
  Transfer: { ic: '🏦', cls: 'transfer' },
};

export default function PaymentRow({ payment, onDelete, readOnly, fallbackUser }) {
  const meta = METHOD_META[payment.method] || { ic: '💳', cls: '' };
  const recordedBy = payment.recordedBy?.username || payment.recordedBy?.name || fallbackUser || '';
  const recordedAt = formatFullDateTime(payment.recordedAt);

  return (
    <div className="pos-pay-row">
      <div className={`pos-pay-icon ${meta.cls}`}>{meta.ic}</div>
      <div className="pos-pay-info">
        <b>{payment.method}</b>
        <div className="pos-pay-audit">
          {recordedAt && <span className="pos-pay-audit-time">{recordedAt}</span>}
          {recordedBy && <span className="pos-pay-audit-user">👤 {recordedBy}</span>}
        </div>
      </div>
      <span className="pos-pay-amt">{ILS(payment.amount)}</span>
      {!readOnly && onDelete && (
        <button className="pos-pay-del" onClick={onDelete} aria-label="Eliminar pago">✕</button>
      )}
    </div>
  );
}
